import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { Menu as MenuIcon } from '@mui/icons-material'

export const NavButton = styled(MenuIcon)`
  color: ${props => props.theme.palette.brand.primary};
  border: 1px solid ${props => props.theme.palette.brand.primary};
  padding: 4px;
  border-radius: 50%;
`
export const HideContainer = styled('div')`
  margin-right: 16px;
  ${props => props.theme.breakpoints.up('md')} {
    display: none;
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`
